import {
    IMM_CTA_BUTTON,
    IMM_CTA_SUBTITLE,
    IMM_CTA_TITLE,
    IMM_DISCLAIMER_BODY,
    IMM_DISCLAIMER_EYEBROW,
    IMM_DISCLAIMER_TITLE,
    IMM_FAQ_A1, IMM_FAQ_A2, IMM_FAQ_A3, IMM_FAQ_A4, IMM_FAQ_A5,
    IMM_FAQ_EYEBROW,
    IMM_FAQ_Q1, IMM_FAQ_Q2, IMM_FAQ_Q3, IMM_FAQ_Q4, IMM_FAQ_Q5,
    IMM_FAQ_SUBTITLE,
    IMM_FAQ_TITLE,
    IMM_HELMET_DESCRIPTION,
    IMM_HELMET_TITLE,
    IMM_HERO_CTA_CALL,
    IMM_HERO_CTA_CONSULT,
    IMM_HERO_EYEBROW,
    IMM_HERO_SUBTITLE,
    IMM_HERO_TITLE,
    IMM_HERO_TITLE_ACCENT,
    IMM_HERO_TRUST_BILINGUAL,
    IMM_HERO_TRUST_FAMILIES,
    IMM_HERO_TRUST_YEARS,
    IMM_PARTNER_EYEBROW,
    IMM_PARTNER_TITLE,
    IMM_PARTNER_SUBTITLE,
    IMM_PARTNER_TAGLINE,
    IMM_PARTNER_TRUST1,
    IMM_PARTNER_TRUST2,
    IMM_PARTNER_TRUST3,
    IMM_PARTNER_INCLUDES,
    IMM_PROCESS_EYEBROW,
    IMM_PROCESS_STEP1_DESC,
    IMM_PROCESS_STEP1_TITLE,
    IMM_PROCESS_STEP2_DESC,
    IMM_PROCESS_STEP2_TITLE,
    IMM_PROCESS_STEP3_DESC,
    IMM_PROCESS_STEP3_TITLE,
    IMM_PROCESS_STEP4_DESC,
    IMM_PROCESS_STEP4_TITLE,
    IMM_PROCESS_TITLE,
    IMM_SERVICES_EYEBROW,
    IMM_SERVICES_SUBTITLE,
    IMM_SERVICES_TITLE,
    IMM_SERVICE_ASYLUM_DESC,
    IMM_SERVICE_ASYLUM_TITLE,
    IMM_SERVICE_CITIZENSHIP_DESC,
    IMM_SERVICE_CITIZENSHIP_TITLE,
    IMM_SERVICE_DACA_DESC,
    IMM_SERVICE_DACA_TITLE,
    IMM_SERVICE_FAMILY_DESC,
    IMM_SERVICE_FAMILY_TITLE,
    IMM_SERVICE_GREENCARD_DESC,
    IMM_SERVICE_GREENCARD_TITLE,
    IMM_SERVICE_RENEWALS_TITLE,
    IMM_SERVICE_RENEWALS_DESC,
    IMM_SERVICE_WORK_DESC,
    IMM_SERVICE_WORK_TITLE,
    IMM_WHY_EYEBROW,
    IMM_WHY_ITEM1_DESC,
    IMM_WHY_ITEM1_TITLE,
    IMM_WHY_ITEM2_DESC,
    IMM_WHY_ITEM2_TITLE,
    IMM_WHY_ITEM3_DESC,
    IMM_WHY_ITEM3_TITLE,
    IMM_WHY_ITEM4_DESC,
    IMM_WHY_ITEM4_TITLE,
    IMM_WHY_SUBTITLE,
    IMM_WHY_TITLE,
} from '../types';

const en_immigration_page = {
    helmet: {
        [IMM_HELMET_TITLE]: 'Immigration Services in Miami | Linares Pro Corp',
        [IMM_HELMET_DESCRIPTION]: 'Bilingual immigration help in Miami Lakes. Green cards, family petitions, work permits, citizenship and DACA — handled by people who care about your family.',
    },
    section: {
        hero: {
            [IMM_HERO_EYEBROW]: 'Immigration services',
            [IMM_HERO_TITLE]: 'Your path to a stronger',
            [IMM_HERO_TITLE_ACCENT]: 'future in the U.S.',
            [IMM_HERO_SUBTITLE]: 'We guide families through every step of the immigration process — from the first consultation to citizenship — with honest advice, bilingual support, and zero surprises.',
            [IMM_HERO_CTA_CONSULT]: 'Book a free consultation',
            [IMM_HERO_CTA_CALL]: 'Call now',
            [IMM_HERO_TRUST_YEARS]: '15+ years of experience',
            [IMM_HERO_TRUST_FAMILIES]: '3,000+ families helped',
            [IMM_HERO_TRUST_BILINGUAL]: '100% bilingual support',
        },
        services: {
            [IMM_SERVICES_EYEBROW]: 'What we handle',
            [IMM_SERVICES_TITLE]: 'Complete immigration support, all under one roof.',
            [IMM_SERVICES_SUBTITLE]: 'Every case is different. We tailor a clear plan for your situation and walk with you the whole way.',
            [IMM_SERVICE_GREENCARD_TITLE]: 'Green card (residency)',
            [IMM_SERVICE_GREENCARD_DESC]: 'Permanent residence applications, adjustments of status, and renewals handled correctly the first time.',
            [IMM_SERVICE_FAMILY_TITLE]: 'Family petitions',
            [IMM_SERVICE_FAMILY_DESC]: 'Reunite with spouses, parents, children and siblings through the right family-based petition.',
            [IMM_SERVICE_WORK_TITLE]: 'Work permits',
            [IMM_SERVICE_WORK_DESC]: 'Employment authorization (EAD), renewals, and guidance on the right work visa category.',
            [IMM_SERVICE_CITIZENSHIP_TITLE]: 'U.S. citizenship',
            [IMM_SERVICE_CITIZENSHIP_DESC]: 'Naturalization (N-400) prep — paperwork, interview coaching and civics study support.',
            [IMM_SERVICE_DACA_TITLE]: 'DACA',
            [IMM_SERVICE_DACA_DESC]: 'Initial requests and timely renewals for Deferred Action for Childhood Arrivals.',
            [IMM_SERVICE_ASYLUM_TITLE]: 'Asylum & humanitarian',
            [IMM_SERVICE_ASYLUM_DESC]: 'Asylum, TPS and humanitarian relief — handled with care and confidentiality.',
            [IMM_SERVICE_RENEWALS_TITLE]: 'Renewals & more',
            [IMM_SERVICE_RENEWALS_DESC]: 'Timely renewals for EADs, green cards, DACA, TPS and other documents — so your status stays current.',
        },
        partner: {
            [IMM_PARTNER_EYEBROW]: 'Our affiliated partner',
            [IMM_PARTNER_TITLE]: 'Immigration services powered by E&W Multiservices LLC',
            [IMM_PARTNER_SUBTITLE]: 'Linares Pro Corp has partnered with E&W Multiservices LLC — a dedicated bilingual immigration document-preparation firm — to bring you a comprehensive, trusted path through every stage of your immigration journey.',
            [IMM_PARTNER_TAGLINE]: 'Your future, our priority.',
            [IMM_PARTNER_INCLUDES]: 'Includes',
            [IMM_PARTNER_TRUST1]: 'Personalized attention',
            [IMM_PARTNER_TRUST2]: 'Professionalism & experience',
            [IMM_PARTNER_TRUST3]: 'Honesty & commitment',
        },
        process: {
            [IMM_PROCESS_EYEBROW]: 'How it works',
            [IMM_PROCESS_TITLE]: 'A clear path, four simple steps.',
            [IMM_PROCESS_STEP1_TITLE]: 'Free consultation',
            [IMM_PROCESS_STEP1_DESC]: 'We listen to your situation, answer your questions, and tell you honestly what is possible.',
            [IMM_PROCESS_STEP2_TITLE]: 'Document review',
            [IMM_PROCESS_STEP2_DESC]: 'We organize and review every document so nothing slows your case down at the worst moment.',
            [IMM_PROCESS_STEP3_TITLE]: 'Filing & follow-up',
            [IMM_PROCESS_STEP3_DESC]: 'We prepare and file your application, then track it with USCIS until you get a response.',
            [IMM_PROCESS_STEP4_TITLE]: 'Interview & approval',
            [IMM_PROCESS_STEP4_DESC]: 'We prepare you for the interview and walk with you all the way to your approval.',
        },
        why: {
            [IMM_WHY_EYEBROW]: 'Why families choose us',
            [IMM_WHY_TITLE]: 'A team that treats your case like family.',
            [IMM_WHY_SUBTITLE]: "We've helped thousands of South Florida families move forward — clearly, honestly, and in your language.",
            [IMM_WHY_ITEM1_TITLE]: 'Bilingual, by people',
            [IMM_WHY_ITEM1_DESC]: 'English and Spanish, every step. Real people you can reach when you need answers.',
            [IMM_WHY_ITEM2_TITLE]: 'Transparent pricing',
            [IMM_WHY_ITEM2_DESC]: 'Clear quotes up front. No surprise fees, no hidden charges.',
            [IMM_WHY_ITEM3_TITLE]: 'Experienced filings',
            [IMM_WHY_ITEM3_DESC]: 'Years of paperwork done right the first time — fewer delays, fewer denials.',
            [IMM_WHY_ITEM4_TITLE]: 'Family-first approach',
            [IMM_WHY_ITEM4_DESC]: 'We treat every case with the care we would give our own family members.',
        },
        faq: {
            [IMM_FAQ_EYEBROW]: 'Questions',
            [IMM_FAQ_TITLE]: 'Common questions, clear answers.',
            [IMM_FAQ_SUBTITLE]: "If you don't see your question here, just call us — we'll talk you through it.",
            [IMM_FAQ_Q1]: 'Are you immigration attorneys?',
            [IMM_FAQ_A1]: 'We are not a law firm. We are a bilingual document-preparation and filing service that helps families complete and submit USCIS forms correctly. For cases that require legal representation, we will refer you to a trusted attorney.',
            [IMM_FAQ_Q2]: 'How much do your services cost?',
            [IMM_FAQ_A2]: 'Pricing depends on the type of case. We always give you a clear written quote before any work begins, so you know exactly what you are paying for.',
            [IMM_FAQ_Q3]: 'How long does an immigration case take?',
            [IMM_FAQ_A3]: 'Processing times depend on USCIS and the type of application — from a few months to a couple of years. We will give you a realistic timeline based on current trends.',
            [IMM_FAQ_Q4]: 'Do I need to come to your office?',
            [IMM_FAQ_A4]: 'We recommend at least one in-person visit so we can review your documents, but many follow-ups can be handled by phone, email, or WhatsApp.',
            [IMM_FAQ_Q5]: 'Can you help even if my case is complicated?',
            [IMM_FAQ_A5]: 'Yes. We will be honest about what we can handle in-house and when we should bring in a partner attorney — your case always comes first.',
        },
        cta: {
            [IMM_CTA_TITLE]: 'Ready to take the next step?',
            [IMM_CTA_SUBTITLE]: 'Your first consultation is free. Let us look at your case together — no pressure, no obligation.',
            [IMM_CTA_BUTTON]: 'Book your free consultation',
        },
        disclaimer: {
            [IMM_DISCLAIMER_EYEBROW]: 'Important Disclosure',
            [IMM_DISCLAIMER_TITLE]: 'We are not attorneys or USCIS agents.',
            [IMM_DISCLAIMER_BODY]: 'Linares Pro Family Service Corp is a bilingual notary and document‑preparation service. We help you correctly complete and submit USCIS and other immigration forms based on the information you provide. We do not give legal advice, do not represent you before USCIS, and we are not affiliated with any government agency. If your case requires legal representation, we will gladly refer you to a trusted licensed immigration attorney.',
        },
    },
};

export default en_immigration_page;
